module.exports = __webpack_public_path__ + "static/img/5.5eb6190.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/zh/5.png
// module id = +NaF
// module chunks = 0